import { useEffect, useState } from "react";
import { Eye } from "lucide-react";
import { useLang } from "@/i18n";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const SESSION_KEY = "jatka_visit_tracked";

export default function VisitCounter() {
  const { lang } = useLang();
  const [count, setCount] = useState(null);

  useEffect(() => {
    let cancelled = false;
    async function track() {
      try {
        const alreadyTracked = sessionStorage.getItem(SESSION_KEY) === "1";
        const url = `${API}/visits`;
        const res = await fetch(url, {
          method: alreadyTracked ? "GET" : "POST",
          headers: { "Content-Type": "application/json" },
        });
        if (!res.ok) return;
        const data = await res.json();
        if (cancelled) return;
        setCount(typeof data.count === "number" ? data.count : null);
        if (!alreadyTracked) sessionStorage.setItem(SESSION_KEY, "1");
      } catch (e) {
        /* silently ignore — counter is non-critical */
      }
    }
    track();
    return () => {
      cancelled = true;
    };
  }, []);

  if (count === null) return null;

  const label = lang === "en" ? "visits" : "odwiedzin";
  return (
    <div
      data-testid="visit-counter"
      className="inline-flex items-center gap-2 text-[11px] uppercase tracking-widest text-[#e7d8bc]/55"
    >
      <Eye className="w-3.5 h-3.5 text-[#c89b6a]/70" />
      <span className="font-serif text-sm tracking-normal normal-case text-[#e7d8bc]/80 tabular-nums">
        {count.toLocaleString(lang === "en" ? "en-US" : "pl-PL")}
      </span>
      <span>{label}</span>
    </div>
  );
}
